<template>
  <div class="manage-login-box">
    <h1 class="" title="Stay Assist"></h1>
    <h2 class="about">Host Sign in</h2>
    <div class="login">
      <form method="post" @submit.prevent="login" autocomplete="on">
        <label class="label">サインインID</label><span class="help is-danger" v-html="e_msg_u_id"></span>
        <p class="control"><input type="text" name="user_id" autocomplete="on" placeholder="サインインID" class="input" v-model="user_id"></p>
        <label class="label">パスワード</label><span class="help is-danger" v-html="e_msg_u_pass"></span>
        <input type="password" name="user_pass" autocomplete="on" placeholder="パスワード" class="input" v-model="user_pass">
        <input class="button" type="submit" value="サインイン">
        <p class="id_save_chk">
          <input type="checkbox" id="id_save_chk" v-model="id_save_chk" @change="id_save()">
          <label for="id_save_chk">サインイン情報を保存する</label>
        </p>

      </form>
    </div>

    <div class="footer">
      Produced by LC&Pe Inc.
    </div>
    <p class="pre-load-font-regular">a</p>
    <p class="pre-load-font-bold">a</p>
  </div>
</template>

<script>
export default {
  name: 'ManageLogin',

  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      e_msg_u_id: '',
      e_msg_u_pass: '',
      user_id: '',
      user_pass: '',
      id_save_chk: false,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    // alert等システム用に日本語を設定
    this.$store.commit('loginInfo/set_lang', 'ja');
    this.$store.commit('loginInfo/set_login_type', 'manage');

    if (localStorage.lcpe) {
      this.id_save_chk = true;
      const obj = JSON.parse(localStorage.lcpe);
      this.user_id = obj.id;
      this.user_pass = obj.pass;
    }
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    if (this.$route.query.type === 'reload') {
      this.$alert('alert', 'ブラウザがリロードされたため、サインアウトしました。\n再度サインインしてください。');
    } else if (this.$route.query.type === 'logout') {
      this.$alert('alert', 'サインアウトしました。');
    }

    document.getElementsByTagName('title')[0].innerHTML = 'Stay Assist (for host)';
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    login () {
      let eFlg = false;
      if (!this.user_id) {
        this.e_msg_u_id = 'サインインIDを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_id = '';
      }
      if (!this.user_pass) {
        this.e_msg_u_pass = 'パスワードを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_pass = '';
      }
      if (eFlg === false) {
        let ld = new this.$loader(this);
        ld._data_set({user_id: this.user_id, user_pass: this.user_pass});
        ld._post_cb_f = this.login_cb;
        ld._load_start('login_admin.php');
      }
    },
    login_cb (data) {
      if (data.res === 1) {
        this.$store.commit('loginInfo/set_data', data.data);
        this.$store.commit('loginInfo/set_owner_info_defect_flag', data.data.owner_info_defect_flag);

        if (this.id_save_chk === true) {
          const obj = JSON.stringify({
            id: this.user_id,
            pass: this.user_pass,
          });
          localStorage.lcpe = obj;
        }

        if (data.data.owner_info_defect_flag === false) {
          this.$router.push({name: 'unregistered', params: {}});
        } else {
          this.$router.push({name: 'owner', params: {}});
        }
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    id_save () {
      if (this.id_save_chk === false) {
        localStorage.removeItem('lcpe');
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.pre-load-font-regular,
.pre-load-font-bold {
  font-family: 'mplus-1p';
  visibility: hidden;
}

.manage-login-box {
  text-align: center;
  padding-top: 50px;
  h1 {
    color: #24273b;
    font-size: 28px;
    letter-spacing: 2px;
    background-image: url('../../assets/logo.svg');
    height: 32px;
    width: 158px;
    margin: 0 auto;
    background-size: cover;
  }
  .about {
    display: inline-block;
    font-size: 18px;
    font-weight: normal;
    color: #24273b;
    margin: 25px auto 25px auto;
    position: relative;
    width: 400px;
    padding: 5px 0;
  }
  .about2 {
    margin-bottom: 0px;
  }
  .about3 {
    color: #1d1b50;
    margin-bottom: 20px;
  }
  input {
    ime-mode: inactive;
    height: 48px;
    font-size: 18px;
  }

  .login {
    position: relative;
    width: 514px;
    margin: 10px auto;
    background: #fbfbfb;
    border: 1px solid #ceced2;
    padding: 32px 112px 40px 112px;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .control {
    margin-bottom: 17px;
  }

  .label {
    text-align: left;
    // float: left;
    color: #24273b;
    padding-left: 8px;
    margin-bottom: 5px;
    display: block;
  }

  .button {
    margin-top: 25px;
    width: 150px;
    height: 40px;
    border: initial;
    border-radius: 4px;
    font-size: 16px;
  }

  .help {
    color: #ff6e5a;
    font-size: 13px;
    line-height: 1.7;
  }

  .title-header {

  }
  .footer {
    // background-image: url('../../assets/lilli.svg');
    background-repeat: no-repeat;
    background-position: right;
    -ms-background-position-x: 55px;

    width: 230px;
    margin: 50px auto 20px auto;
    text-align: left;
    height: 40px;
    line-height: 40px;
    color: #24273b;
    text-align: center;
  }
  .id_save_chk {
    margin-top: 24px;
  }

  @media (max-width: 767px) {
    padding-top: 25px;
    h1 {
      font-size: 20px;
      letter-spacing: 0px;
    }
    .login {
      width: calc(100vw - 110px);
      padding: 18px 15px 22px 15px;
      box-sizing: inherit;
    }
    .about {
      width: calc(100vw - 110px);
    }
  }
}
</style>
